import { withSuspendAtom } from "../../utils/jotai/withSuspendAtom"
import { queryClient, trpc } from "../../utils/trpc"

export const getMetricsAtom = withSuspendAtom(async () => {
  const results = await queryClient.ensureQueryData(
    trpc.metrics.getMetricsConfiguration.queryOptions(undefined),
  )

  return {
    ok: {
      data: results.data,
    },
    err: null,
  }
})
